import { EditableContent } from '../hooks/useEditableContent';

export const deratisationDefaultContent: EditableContent = {
  pageTitle: 'Dératisation Professionnelle',
  pageSubtitle: 'Solutions efficaces et durables contre les rongeurs',
  heroImage: {
    url: 'https://public.readdy.ai/ai/img_res/a10087a1c927c7634b95f19705710d46.jpg',
    alt: 'Dératisation professionnelle'
  },
  descriptionTitle: 'Pourquoi faire appel à un professionnel ?',
  descriptionText1: 'Les rongeurs (rats, souris) représentent un danger sanitaire majeur pour votre habitation ou votre entreprise. Ils peuvent transmettre des maladies graves, contaminer les denrées alimentaires et causer des dégâts matériels importants (câbles électriques, isolation, etc.).',
  descriptionText2: 'Notre équipe certifiée intervient rapidement avec des méthodes adaptées à chaque situation. Nous utilisons des produits professionnels homologués et respectueux de l\'environnement pour garantir une élimination totale et durable des rongeurs.',
  descriptionImage: {
    url: 'https://readdy.ai/api/search-image?query=close%20up%20of%20professional%20rodent%20control%20equipment%20including%20modern%20traps%20bait%20stations%20and%20monitoring%20devices%20arranged%20on%20clean%20surface%20with%20technical%20diagrams%20in%20background%20professional%20product%20photography%20style%20simple%20neutral%20background%20high%20detail%20focus%20on%20pest%20control%20technology&width=600&height=400&seq=deratisation-equipment-v2&orientation=landscape',
    alt: 'Équipement de dératisation'
  },
  descriptionFeatures: [
    {
      icon: 'ri-shield-check-line',
      title: 'Intervention rapide',
      description: 'Déplacement sous 24h dans tout le Var'
    },
    {
      icon: 'ri-leaf-line',
      title: 'Produits certifiés',
      description: 'Solutions homologuées et écologiques'
    },
    {
      icon: 'ri-time-line',
      title: 'Garantie résultat',
      description: 'Suivi et contrôle inclus'
    }
  ],
  methodsTitle: 'Nos méthodes d\'intervention',
  methodsSubtitle: 'Des solutions adaptées à chaque situation',
  methods: [
    {
      icon: 'ri-search-eye-line',
      title: 'Diagnostic complet',
      description: 'Inspection minutieuse des lieux pour identifier les zones à risque, les points d\'entrée et le niveau d\'infestation'
    },
    {
      icon: 'ri-flask-line',
      title: 'Traitement ciblé',
      description: 'Mise en place de stations d\'appâtage sécurisées et de pièges adaptés aux zones identifiées'
    },
    {
      icon: 'ri-shield-line',
      title: 'Prévention',
      description: 'Colmatage des accès, conseils personnalisés et mise en place de mesures préventives durables'
    },
    {
      icon: 'ri-refresh-line',
      title: 'Suivi régulier',
      description: 'Contrôles périodiques pour garantir l\'efficacité du traitement et prévenir toute réinfestation'
    }
  ],
  methodsInfo: {
    title: 'Une approche professionnelle et sécurisée',
    content: 'Tous nos traitements respectent les normes en vigueur et sont réalisés par des techniciens certifiés. Nous adaptons nos méthodes selon le type de bâtiment (habitation, commerce, industrie) et la gravité de l\'infestation.'
  },
  tarifsTitle: 'Nos tarifs',
  tarifsSubtitle: 'Des formules adaptées à vos besoins',
  tarifs: [
    {
      title: 'Intervention ponctuelle',
      subtitle: 'Pour une infestation légère',
      price: '120€',
      priceSubtitle: 'à partir de',
      features: [
        'Diagnostic complet',
        'Traitement initial',
        'Conseils de prévention',
        'Garantie 30 jours'
      ],
      buttonText: 'Demander un devis'
    },
    {
      title: 'Formule complète',
      subtitle: 'Pour une élimination totale',
      price: '250€',
      priceSubtitle: 'à partir de',
      features: [
        'Diagnostic approfondi',
        'Traitement complet',
        '2 passages de contrôle',
        'Colmatage des accès',
        'Garantie 90 jours'
      ],
      isPopular: true,
      buttonText: 'Demander un devis'
    },
    {
      title: 'Contrat annuel',
      subtitle: 'Pour les professionnels',
      price: 'Sur devis',
      priceSubtitle: 'selon surface',
      features: [
        'Visites préventives régulières',
        'Interventions illimitées',
        'Rapport d\'intervention',
        'Garantie annuelle',
        'Tarif préférentiel'
      ],
      buttonText: 'Nous contacter'
    }
  ],
  faqTitle: 'Questions fréquentes',
  faqSubtitle: 'Tout ce que vous devez savoir sur la dératisation',
  faqs: [
    {
      question: 'Combien de temps dure une intervention de dératisation ?',
      answer: 'Une intervention standard dure entre 1h et 2h selon la surface et le niveau d\'infestation. Le traitement complet nécessite généralement 2 à 3 passages espacés de 7 à 15 jours.'
    },
    {
      question: 'Les produits utilisés sont-ils dangereux pour mes animaux domestiques ?',
      answer: 'Nous utilisons des stations d\'appâtage sécurisées inaccessibles aux animaux domestiques et aux enfants. Nos techniciens vous donnent toutes les consignes de sécurité lors de l\'intervention.'
    },
    {
      question: 'Comment savoir si j\'ai des rongeurs chez moi ?',
      answer: 'Les signes d\'une infestation incluent : bruits de grattement la nuit, présence d\'excréments, traces de grignotage sur les aliments ou les câbles, odeur d\'urine, traces de passage (graisse sur les murs).'
    },
    {
      question: 'Que faire en attendant votre intervention ?',
      answer: 'Stockez les denrées alimentaires dans des contenants hermétiques, bouchez temporairement les trous visibles, maintenez une hygiène irréprochable et évitez de laisser de la nourriture accessible.'
    },
    {
      question: 'Proposez-vous des interventions en urgence ?',
      answer: 'Oui, nous intervenons sous 24h dans tout le Var pour les situations urgentes. Contactez-nous par téléphone pour une prise en charge rapide.'
    }
  ],
  faqContactText: 'Vous avez d\'autres questions ?',
  faqContactSubtext: 'Notre équipe est à votre disposition pour répondre à toutes vos interrogations',
  formTitle: 'Demande d\'intervention',
  formSubtitle: 'Remplissez ce formulaire pour obtenir un devis gratuit sous 24h'
};

export const desinsectisationDefaultContent: EditableContent = {
  pageTitle: 'Désinsectisation Professionnelle',
  pageSubtitle: 'Élimination efficace de tous types d\'insectes nuisibles',
  heroImage: {
    url: 'https://readdy.ai/api/search-image?query=professional%20pest%20control%20technician%20in%20full%20protective%20equipment%20spraying%20treatment%20for%20insects%20including%20visible%20cockroaches%20asian%20hornets%20bedbugs%20and%20ants%20in%20modern%20clean%20interior%20realistic%20professional%20photography%20simple%20background%20focus%20on%20pest%20control%20action&width=1200&height=600&seq=desinsectisation-hero-v3&orientation=landscape',
    alt: 'Désinsectisation professionnelle'
  },
  descriptionTitle: 'Protection contre les insectes nuisibles',
  descriptionText1: 'Les insectes nuisibles (cafards, punaises de lit, frelons asiatiques, fourmis, guêpes) peuvent rapidement envahir votre espace et causer des nuisances importantes. Certains présentent des risques sanitaires, d\'autres peuvent causer des dégâts matériels ou des réactions allergiques.',
  descriptionText2: 'R3D Nuisibles dispose de l\'expertise et des équipements nécessaires pour traiter efficacement tous types d\'infestations d\'insectes. Nos méthodes respectent les normes environnementales tout en garantissant une élimination complète et durable.',
  descriptionImage: {
    url: 'https://readdy.ai/api/search-image?query=professional%20insect%20pest%20control%20equipment%20including%20sprayers%20foggers%20and%20treatment%20products%20arranged%20on%20clean%20surface%20with%20safety%20equipment%20modern%20professional%20product%20photography%20simple%20neutral%20background%20high%20detail%20technical%20focus&width=600&height=400&seq=desinsectisation-equipment-v2&orientation=landscape',
    alt: 'Équipement de désinsectisation'
  },
  descriptionFeatures: [
    {
      icon: 'ri-bug-line',
      title: 'Tous insectes',
      description: 'Cafards, punaises, frelons, fourmis, guêpes...'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Traitement garanti',
      description: 'Efficacité prouvée avec suivi inclus'
    },
    {
      icon: 'ri-user-star-line',
      title: 'Techniciens certifiés',
      description: 'Formation continue et équipements professionnels'
    }
  ],
  methodsTitle: 'Nos interventions',
  methodsSubtitle: 'Des traitements adaptés à chaque type d\'insecte',
  methods: [
    {
      icon: 'ri-bug-2-line',
      title: 'Cafards & Blattes',
      description: 'Traitement par gel, pulvérisation ou fumigation selon le niveau d\'infestation. Efficace sur toutes les espèces de cafards.'
    },
    {
      icon: 'ri-hotel-bed-line',
      title: 'Punaises de lit',
      description: 'Traitement thermique ou chimique ciblé. Inspection minutieuse et élimination complète des œufs et adultes.'
    },
    {
      icon: 'ri-contrast-drop-line',
      title: 'Frelons & Guêpes',
      description: 'Destruction de nids en hauteur avec équipement spécialisé. Intervention sécurisée par techniciens équipés.'
    },
    {
      icon: 'ri-plant-line',
      title: 'Fourmis',
      description: 'Traitement des colonies et des chemins de passage. Solutions préventives pour éviter les réinfestations.'
    }
  ],
  methodsInfo: {
    title: 'Une expertise reconnue',
    content: 'Chaque intervention commence par un diagnostic précis pour identifier l\'espèce, le niveau d\'infestation et les causes. Nous adaptons ensuite notre traitement pour une efficacité maximale et durable.'
  },
  tarifsTitle: 'Nos tarifs',
  tarifsSubtitle: 'Des solutions pour chaque situation',
  tarifs: [
    {
      title: 'Traitement standard',
      subtitle: 'Cafards, fourmis, araignées',
      price: '90€',
      priceSubtitle: 'à partir de',
      features: [
        'Diagnostic de l\'infestation',
        'Traitement adapté',
        'Conseils de prévention',
        'Garantie 30 jours'
      ],
      buttonText: 'Demander un devis'
    },
    {
      title: 'Traitement spécialisé',
      subtitle: 'Punaises de lit, frelons',
      price: '200€',
      priceSubtitle: 'à partir de',
      features: [
        'Inspection complète',
        'Traitement professionnel',
        'Passage de contrôle',
        'Garantie 60 jours',
        'Rapport d\'intervention'
      ],
      isPopular: true,
      buttonText: 'Demander un devis'
    },
    {
      title: 'Contrat préventif',
      subtitle: 'Pour les professionnels',
      price: 'Sur devis',
      priceSubtitle: 'selon besoins',
      features: [
        'Visites programmées',
        'Interventions illimitées',
        'Traçabilité complète',
        'Garantie annuelle',
        'Tarif avantageux'
      ],
      buttonText: 'Nous contacter'
    }
  ],
  faqTitle: 'Questions fréquentes',
  faqSubtitle: 'Vos questions sur la désinsectisation',
  faqs: [
    {
      question: 'Comment se déroule un traitement contre les punaises de lit ?',
      answer: 'Nous réalisons d\'abord une inspection complète pour localiser tous les foyers. Le traitement combine généralement méthode thermique (vapeur sèche) et traitement chimique ciblé. Un second passage est effectué 15 jours après pour éliminer les œufs éclos.'
    },
    {
      question: 'Les traitements sont-ils sans danger pour ma famille ?',
      answer: 'Oui, nous utilisons des produits homologués et respectons strictement les protocoles de sécurité. Selon le traitement, une absence temporaire de 2 à 4 heures peut être nécessaire. Nous vous donnons toutes les consignes précises.'
    },
    {
      question: 'Combien de temps faut-il pour éliminer une infestation de cafards ?',
      answer: 'Le traitement initial est efficace dès les premières 48h. Une élimination complète nécessite généralement 2 passages espacés de 15 jours pour traiter les nouvelles éclosions. La durée dépend du niveau d\'infestation.'
    },
    {
      question: 'Intervenez-vous pour les nids de frelons asiatiques en hauteur ?',
      answer: 'Oui, nous disposons de l\'équipement nécessaire (perches télescopiques, nacelle si besoin) et des protections adaptées pour intervenir en toute sécurité sur les nids en hauteur, même difficiles d\'accès.'
    },
    {
      question: 'Que faire si les insectes reviennent après le traitement ?',
      answer: 'Nos traitements sont garantis. Si vous constatez une réinfestation pendant la période de garantie, nous intervenons à nouveau sans frais supplémentaires. Contactez-nous dès les premiers signes.'
    }
  ],
  faqContactText: 'Une question spécifique ?',
  faqContactSubtext: 'Contactez-nous pour un conseil personnalisé',
  formTitle: 'Demande d\'intervention',
  formSubtitle: 'Décrivez votre problème pour recevoir un devis adapté'
};

export const desinfectionDefaultContent: EditableContent = {
  pageTitle: 'Désinfection Professionnelle',
  pageSubtitle: 'Assainissement et désinfection de tous types de locaux',
  heroImage: {
    url: 'https://readdy.ai/api/search-image?query=professional%20disinfection%20technician%20in%20full%20white%20protective%20suit%20and%20mask%20spraying%20disinfectant%20in%20modern%20clean%20interior%20room%20with%20professional%20equipment%20realistic%20photography%20style%20simple%20clean%20background%20focus%20on%20sanitization%20process%20and%20safety%20equipment&width=1200&height=600&seq=desinfection-hero-v3&orientation=landscape',
    alt: 'Désinfection professionnelle'
  },
  descriptionTitle: 'Désinfection et assainissement',
  descriptionText1: 'La désinfection professionnelle est essentielle pour éliminer virus, bactéries et agents pathogènes dans vos locaux. Que ce soit après une contamination, dans le cadre d\'une prévention sanitaire ou pour respecter les normes d\'hygiène, nos interventions garantissent un environnement sain.',
  descriptionText2: 'R3D Nuisibles utilise des protocoles de désinfection conformes aux normes en vigueur. Nos produits virucides et bactéricides sont efficaces contre un large spectre de micro-organismes tout en respectant votre environnement.',
  descriptionImage: {
    url: 'https://readdy.ai/api/search-image?query=professional%20disinfection%20equipment%20including%20fogger%20sprayer%20bottles%20protective%20gear%20and%20cleaning%20products%20arranged%20on%20clean%20white%20surface%20modern%20product%20photography%20simple%20neutral%20background%20high%20detail%20focus%20on%20sanitization%20technology&width=600&height=400&seq=desinfection-equipment-v2&orientation=landscape',
    alt: 'Équipement de désinfection'
  },
  descriptionFeatures: [
    {
      icon: 'ri-virus-line',
      title: 'Virucide & Bactéricide',
      description: 'Produits certifiés à large spectre'
    },
    {
      icon: 'ri-building-line',
      title: 'Tous locaux',
      description: 'Habitations, commerces, industries'
    },
    {
      icon: 'ri-file-list-line',
      title: 'Certificat fourni',
      description: 'Attestation d\'intervention conforme'
    }
  ],
  methodsTitle: 'Nos prestations',
  methodsSubtitle: 'Des solutions de désinfection adaptées',
  methods: [
    {
      icon: 'ri-home-smile-line',
      title: 'Désinfection habitation',
      description: 'Traitement complet de votre logement après contamination, décès ou pour assainissement préventif.'
    },
    {
      icon: 'ri-store-line',
      title: 'Désinfection commerce',
      description: 'Respect des normes HACCP pour restaurants, commerces alimentaires et établissements recevant du public.'
    },
    {
      icon: 'ri-hospital-line',
      title: 'Désinfection médicale',
      description: 'Protocoles renforcés pour cabinets médicaux, laboratoires et établissements de santé.'
    },
    {
      icon: 'ri-car-line',
      title: 'Désinfection véhicules',
      description: 'Assainissement complet de véhicules particuliers, utilitaires ou de transport de personnes.'
    }
  ],
  methodsInfo: {
    title: 'Protocoles certifiés',
    content: 'Nos interventions suivent des protocoles stricts : préparation des surfaces, application par nébulisation ou pulvérisation, temps de contact respecté, aération contrôlée. Chaque intervention fait l\'objet d\'un rapport détaillé.'
  },
  tarifsTitle: 'Nos tarifs',
  tarifsSubtitle: 'Tarification selon le type de local',
  tarifs: [
    {
      title: 'Désinfection simple',
      subtitle: 'Pièce ou petit local',
      price: '80€',
      priceSubtitle: 'à partir de',
      features: [
        'Jusqu\'à 30m²',
        'Pulvérisation virucide',
        'Surfaces et air',
        'Attestation fournie'
      ],
      buttonText: 'Demander un devis'
    },
    {
      title: 'Désinfection complète',
      subtitle: 'Logement ou commerce',
      price: '150€',
      priceSubtitle: 'à partir de',
      features: [
        'Jusqu\'à 100m²',
        'Nébulisation professionnelle',
        'Traitement approfondi',
        'Certificat de désinfection',
        'Garantie sanitaire'
      ],
      isPopular: true,
      buttonText: 'Demander un devis'
    },
    {
      title: 'Contrat sanitaire',
      subtitle: 'Professionnels & collectivités',
      price: 'Sur devis',
      priceSubtitle: 'selon surface',
      features: [
        'Interventions programmées',
        'Protocole personnalisé',
        'Traçabilité complète',
        'Conformité HACCP',
        'Tarif préférentiel'
      ],
      buttonText: 'Nous contacter'
    }
  ],
  faqTitle: 'Questions fréquentes',
  faqSubtitle: 'Tout savoir sur la désinfection',
  faqs: [
    {
      question: 'Quelle est la différence entre nettoyage et désinfection ?',
      answer: 'Le nettoyage élimine les salissures visibles. La désinfection va plus loin en détruisant les micro-organismes invisibles (virus, bactéries, champignons) grâce à des produits biocides certifiés. Les deux sont complémentaires.'
    },
    {
      question: 'Combien de temps dure une désinfection ?',
      answer: 'L\'intervention dure entre 30 minutes et 2 heures selon la surface. Il faut ensuite respecter un temps de contact (généralement 1h) puis une aération de 30 minutes avant de réintégrer les lieux.'
    },
    {
      question: 'Les produits utilisés sont-ils sans danger ?',
      answer: 'Nous utilisons des produits homologués, efficaces mais à utilisation professionnelle. C\'est pourquoi nous respectons des protocoles stricts et vous donnons toutes les consignes de sécurité. Une fois le délai d\'aération respecté, les lieux sont parfaitement sûrs.'
    },
    {
      question: 'Faut-il désinfecter après un décès à domicile ?',
      answer: 'Oui, c\'est fortement recommandé, notamment en cas de découverte tardive. Nous intervenons avec discrétion et professionnalisme pour assainir complètement les lieux et éliminer tout risque sanitaire.'
    },
    {
      question: 'Délivrez-vous un certificat de désinfection ?',
      answer: 'Oui, chaque intervention fait l\'objet d\'une attestation détaillée mentionnant les produits utilisés, les surfaces traitées et la date d\'intervention. Ce document peut être exigé par certaines assurances ou administrations.'
    }
  ],
  faqContactText: 'Besoin d\'informations complémentaires ?',
  faqContactSubtext: 'Notre équipe vous conseille sur la solution adaptée',
  formTitle: 'Demande de désinfection',
  formSubtitle: 'Contactez-nous pour une intervention rapide'
};